  <app-m-layout-header class="header-block"></app-m-layout-header>

  <div class="container-layout">
    
    <div class="container-layout-menu" [class.menu-opened]="layoutDataService.bSubToggleMenuPanel.value">
      <app-m-layout-menu-full></app-m-layout-menu-full>
    </div>

    <div class="container-layout-content" [class.menu-opened]="layoutDataService.bSubToggleMenuPanel.value"> 

      <div class="container-layout-widgets" 
        [class.widget-hidden]="showWidgets === false" 
        [class.menu-opened]="layoutDataService.bSubToggleMenuPanel.value">
        <app-widgets-board  [editMode]="true"></app-widgets-board>
      </div>

      <ng-component></ng-component>
      <ng-content></ng-content>
  </div>
  
</div>